// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Logput_Wrapper__KCCtE","Content":"Logput_Content__hj43D"};